import { formatDateRange } from '@bonhams1793/bonhams-typescript'

import { stripTags } from '../stripTags/stripTags'

interface BuildSpecialistEmailSubjectProps {
  auctionId: number
  auctionStartDate: string
  auctionEndDate: string
  auctionName: string
  auctionTimezone: string
  lotId?: number
  lotDescription?: string
  lotExhibition?: boolean
  lotFullId?: string
}

export function buildSpecialistEmailSubject({
  auctionId,
  auctionStartDate,
  auctionEndDate,
  auctionName,
  auctionTimezone,
  lotId,
  lotDescription,
  lotExhibition,
  lotFullId,
}: BuildSpecialistEmailSubjectProps) {
  let title, lotNumber
  const auctionNumber = `Auction ${auctionId}`
  const date = formatDateRange({
    startDate: auctionStartDate,
    endDate: auctionEndDate,
    timeZone: auctionTimezone,
    options: {
      hideTime: true,
    },
  })

  if (lotId !== undefined) {
    const lotType = lotExhibition ? 'Item' : 'Lot'
    lotNumber = lotId !== 0 ? `${lotType} ${lotId}${lotFullId}` : 'Preview Lot'

    title = lotDescription && stripTags(lotDescription)
  } else {
    title = auctionName
  }

  return `Re: ${
    lotNumber ? lotNumber + ', ' : ''
  }${auctionNumber}, ${title}, ${date}`
}
